import CONFIGURATION from "../configuration";
import ObjectsType from "../constants/ObjectsType";

export function url(target: $TSFixMe) {
  return `${CONFIGURATION.BASE_URL}${target}`;
}

/* istanbul ignore next */
export function redirectTo(target: $TSFixMe) {
  /* istanbul ignore next */
  window.location.href = url(target);
}

export function reload() {
  window.location.reload();
}

function toDocumentTop() {
  document.body.scrollTop = 0; // For Chrome, Safari and Opera
  document.documentElement.scrollTop = 0; // For IE and FF
}

export function navigateTo(target: $TSFixMe, reloadTarget = false) {
  if ((window as $TSFixMe)?.app?.browserHistory) {
    (window as $TSFixMe).app.browserHistory.push(url(target));
    toDocumentTop();
    if (reloadTarget) {
      reload();
    }
  }
}

/* istanbul ignore next */
export function scrollToTop() {
  window.scrollTo(0, 0);
}

export function goBack() {
  (window as $TSFixMe).app.browserHistory.goBack();
}

export function isTouchDevice() {
  return (
    "ontouchstart" in window || navigator.maxTouchPoints > 0 // works on most browsers
  ); // works on IE10/11 and Surface
}

export function isMobileDevice(): boolean {
  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i;
  const macTouch = /Intel Mac/i;

  if (mobileRegex.exec(navigator.userAgent)) {
    return true;
  }

  if (
    macTouch.exec(navigator.userAgent) &&
    navigator.maxTouchPoints > 1 &&
    !(window as { MSStream?: unknown }).MSStream
  ) {
    return true;
  }

  return false;
}

/* istanbul ignore next */
export function redirectToExtern(target: $TSFixMe) {
  /* istanbul ignore next */
  window.window.location.href = target;
}

export function redirectToExternNewWindow(ulr: $TSFixMe) {
  /* istanbul ignore next */
  window.open(ulr, "_blank");
}
/* istanbul ignore next */
export function stripUrlOptions(urlPath: $TSFixMe) {
  return urlPath.toString().split("?")[0];
}
/* istanbul ignore next */
export function currentUrl() {
  return window.location.href;
}

export function locale() {
  /* istanbul ignore next */
  return (
    navigator.languages?.[0] ||
    navigator.language ||
    (navigator as $TSFixMe).userLanguage
  );
}

export function getBrowserLanguageWithoutRegion() {
  return locale().split("-")[0];
}

export function isMobileView() {
  return window.innerWidth <= 768;
}

export function getObjectType(pathname: $TSFixMe) {
  const regex = new RegExp(Object.values(ObjectsType).join("|"), "i");
  const match = pathname.match(regex);
  return match ? match[0] : "";
}

/* needed for integration test */
// @ts-expect-error TS(2551) FIXME: Property 'navigateTo' does not exist on type 'Wind... Remove this comment to see the full error message
window.navigateTo = navigateTo;
